import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4ff718f6: FaireBrandEntity = {
  token: "b_4ff718f6",
  type: "brand",
  name: "Basic Spirit",
  avatarUrl:
    "https://cdn.faire.com/fastly/6b0de54e2f8d17097d3949a025ce5af184ac5fb09158c24db385503d47451515.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/14e1568282fa1d9180a9e6a107052a233be4b8ff81fba37f376b5c6cfea20c36.png",
  logoUrl:
    "https://cdn.faire.com/fastly/6b0de54e2f8d17097d3949a025ce5af184ac5fb09158c24db385503d47451515.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/14e1568282fa1d9180a9e6a107052a233be4b8ff81fba37f376b5c6cfea20c36.png",
  location: "Pugwash, NS, CAN",
  minimumOrderDollars: 274,
  rating: 5,
  reviewCount: 285,
  isTopShop: true,
  isInsider: false,
  description:
    "Basic Spirit is a homegrown company located in the Seaside Village of Pugwash, Nova Scotia. We love creating gifts that touch the heart & delight the spirit. Using traditional methods of pewter smithing with high-quality, lead-free metal, we put a fresh twist on our line of fine pewter. We enjoy the challenge of growing a company, doing our best to serve our customers, and staying open to new possibilities. \n\nOur village of Pugwash is located on the North Shore of our province. Its reputation for peace stems from the conferences that were held here at the thinkers lodge national historic site. In 1995, the Pugwash conferences on science & world affairs won the Nobel Peace Prize, along with its mentor, Sir Joseph Rotblat. \n\nMaybe it's the daily ebb and flow of our tides that renews our hope for peace in ourselves and in our world. We join other individuals and businesses in celebrating the privilege we have to help foster a healthy & loving world.\n\n10& of profits fund charitable projects.  ",
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:45:00.405Z",
    importedBy: "entity-db-cli",
  },
};
